import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  tableCellAction: {
    color: theme.palette.primary.sideBarIconColor,
    opacity: '0.7',
    paddingTop: '6px',
    paddingBottom: '6px',
    '& > a': {
      '& > svg': {
        marginTop: '4px',
        padding: '6px!important',
        fontSize: '1.2rem',
        '& > path': {
          color: theme.palette.primary.sideBarIconColor,
        },
      },
      '& > svg:hover': {
        background: 'rgba(61, 61, 61, 0.05)',
        borderRadius: '50%',
      },
      '& > span': {
        marginTop: '4px',
        padding: '6px!important',
        fontSize: '1.2rem',
      },
      '& > span:hover': {
        background: 'rgba(61, 61, 61, 0.05)',
        borderRadius: '50%',
      },
    },
    '& > svg': {
      marginTop: '4px',
      padding: '6px!important',
      fontSize: '1.2rem',
      cursor: 'pointer',
    },
    '& > svg:hover': {
      background: 'rgba(61, 61, 61, 0.05)',
      borderRadius: '50%',
    },
    '& > span': {
      marginTop: '4px',
      padding: '6px!important',
      fontSize: '1.2rem',
    },
    '& > span:hover': {
      background: 'rgba(61, 61, 61, 0.05)',
      borderRadius: '50%',
    },
  },
  removeCell: {
    textAlign: 'end',
    '& > svg': {
      marginTop: '4px',
      cursor: 'pointer',
      padding: '6px!important',
      fontSize: '1.2rem!important',
    },
  },
  listItemText: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'revert',
    },
  },
  tableCellItem: {
    wordBreak: 'break-word',
  },
  sortedCeil: {
    fontWeight: '500!important',
  },
  copyIcon: {
    cursor: 'pointer',
  },
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  noWrap: {
    whiteSpace: 'nowrap',
    paddingRight: '10px',
  },
  listCountTooltip: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.12)',
    borderRadius: 1,
    px: 2.5,
    py: 1.5,
  },
  listCountEmpty: {
    color: theme.palette.text.secondary,
  },
  listCountTooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.5,
  },
  listCountTooltipItem: {
    fontSize: '0.78rem',
    fontWeight: 500,
  },
  statusChip: {
    height: 24,
    fontSize: '0.72rem',
    fontWeight: 600,
    borderRadius: 999,
  },
  statusChipPending: {
    backgroundColor: '#bbd3f1',
    color: '#1a5787',
  },
  statusChipLocked: {
    backgroundColor: '#c7c7c7',
    color: '#3d3d3d',
  },
  statusChipLive: {
    backgroundColor: '#eaf6f0',
    color: '#29a36a',
  },
  statusChipUnlisted: {
    backgroundColor: '#f8f2e7',
    color: '#b87c14',
  },
};
